import React, { forwardRef, useContext, useState } from 'react'

import { Button as SlabButton } from '../Button'
import { ModalContext } from './context'

interface ButtonProps extends React.ComponentProps<typeof SlabButton> {
  onClick?: (
    event: React.MouseEvent<HTMLButtonElement>
  ) => Promise<void | boolean> | (void | boolean);
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, forwardedRef) => {
    const { dismissModal } = useContext(ModalContext)

    const [isPending, setPending] = useState(false)

    return (
      <SlabButton
        {...props}
        disabled={props.disabled ?? isPending}
        ref={forwardedRef}
        size={props.size ?? 'small'}
        onClick={async (event) => {
          setPending(true)
          try {
            const result = await props.onClick?.(event)
            if (result !== false) dismissModal()
          } finally {
            setPending(false)
          }
        }}
      />
    )
  }
)

Button.displayName = 'Modal.Button'
